import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ---- Leads ----
export const submitLead = (data) => api.post('/leads', data);

// ---- Content ----
export const getMetrics = () => api.get('/metrics');
export const getLogos = () => api.get('/logos');
export const getSolutions = () => api.get('/solutions');
export const getSolution = (slug) => api.get(`/solutions/${slug}`);
export const getServices = () => api.get('/services');
export const getService = (slug) => api.get(`/services/${slug}`);
export const getCases = () => api.get('/cases');
export const getCase = (slug) => api.get(`/cases/${slug}`);
export const getHardwareCategories = () => api.get('/hardware/categories');
export const getHardwareCategory = (slug) => api.get(`/hardware/categories/${slug}`);
export const getProducts = (category) => api.get(`/products${category ? `?category=${category}` : ''}`);
export const getOffers = (limit = 24) => api.get(`/products?show_in_offers=true&limit=${limit}`);
/** Fallback: productos marcados solo como liquidación (sin el flag de promoción home) */
export const getLiquidationProducts = (limit = 24) => api.get(`/products?liquidacion=true&limit=${limit}`);
/** Home Offers: union de productos en oferta (show_in_offers=true) Y/O liquidación (liquidacion=true).
 *  Una sola llamada, ordenada por display_order ASC + created_at DESC. */
export const getHomeOffers = (limit = 24) => api.get(`/products?offers_or_liquidation=true&limit=${limit}`);
export const getProduct = (slug) => api.get(`/products/${slug}`);
export const getSoftware = () => api.get('/software');
export const getSoftwareDetail = (slug) => api.get(`/software/${slug}`);
export const submitContact = (data) => api.post('/contact', data);

export default api;
